import { getHours } from "date-fns";

export const removeDuplicateClassSlots = (slots) => {
  const classSlots = slots.filter(slot => typeof slot === 'object');
  
  classSlots.forEach((classSlot) => {
    const classHour = getHours(new Date(classSlot.starts_at));
    const timeSlotIndex = slots.findIndex(slot => 
      typeof slot === 'string' && +slot.split(':')[0] === classHour
    );
    
    if (timeSlotIndex !== -1) {
      slots.splice(timeSlotIndex, 1);
    }
  });
  
  return slots;
};